export function convertArtist(artists: { name: string }[]) {
  return artists[0].name
}
